import {
  MAX_LOADED_SNAPSHOTS_FROM,
  MAX_LOADED_SNAPSHOTS_TO,
} from '@ipfabric/utils';

export const snapshotCollectionMessages = {
  en: {
    title: 'Snapshot collection',
    boxTitle: 'Snapshot creation',
    enabled: 'Create Snapshots Periodically',
    interval: 'Snapshot interval',
    btnSave: 'Save changes',
    intervalAddon: 'min',
    maxLoaded: 'Maximum Number of Loaded Snapshots',
    maxLocked: 'Maximum Number of Locked Snapshots',
    retention: {
      title: 'Collection rules',
      removalConditionsTitle: 'Deletion rules',
      removalConditionsExplanation:
        'When machine reaches one of these limits, oldest unprotected (not matching Collection rules) snapshots are always removed. If limits below are still exceeded, oldest protected snapshots are also removed. Also new snapshots may not be created.',
      btnRestore: 'Reset to default values',
      confirmRestore: {
        header: 'Retention setting will be restored to defaults',
        subHeader: 'Are you sure you want to overwrite current settings?',
        btnConfirm: 'Restore',
        btnSecondaryConfirm: 'Cancel',
      },
      all: {
        label: 'Keep all snapshots for',
        unit: 'day(s)',
      },
      firstOfDay: {
        label: (
          <>
            Keep first snapshot of the <strong>day</strong> for
          </>
        ),
        unit: 'day(s)',
      },
      firstOfWeek: {
        label: (
          <>
            Keep first snapshot of the <strong>week</strong> for
          </>
        ),
        unit: 'week(s)',
      },
      firstOfMonth: {
        label: (
          <>
            Keep first snapshot of the <strong>month</strong> for
          </>
        ),
        unit: 'month(s)',
      },
      firstOfYear: {
        label: (
          <>
            Keep first snapshot of the <strong>year</strong> for
          </>
        ),
        unit: 'year(s)',
      },
      hddUtilization: {
        label: 'HDD capacity threshold',
        unit: '%',
      },
      snapshotsCount: {
        label: 'Snapshot count threshold',
      },
    },
    validation: {
      required: 'Required',
      range: 'Interval must be from 5 minutes to 1 week (10080 minutes).',
      maxLoadedRange: `Maximum number of loaded snapshots must be between ${MAX_LOADED_SNAPSHOTS_FROM} and ${MAX_LOADED_SNAPSHOTS_TO}.`,
      maxLockedRange:
        'Maximum number of locked snapshots must be positive and less than maximum number of loaded snapshots.',
    },
  },
};
